const capitalisedSnakeCaseToTitleCase = (s) => {
    const titled = s.toLowerCase()
        .replace(/^[-_]*(.)/, (_, c) => c.toUpperCase()) // Initial char (after -/_)
        .replace(/[-_]+(.)/g, (_, c) => ` ${c.toUpperCase()}`); // First char after each -/_
    const trimmed = titled.trim();
    return trimmed;
};

export default capitalisedSnakeCaseToTitleCase;
